@for (depProject of depProjects$ | async; track depProject) {
  <app-dep [depProject]="depProject"></app-dep>
}
